import type { UseFormReturn } from 'react-hook-form';
import type { Metric } from '@gonfalon/metrics/types';

import { ClickMetricDetails } from '../internal/CreateMetricModal/ClickMetricDetails';
import { CustomMetricKindDetails } from '../internal/CreateMetricModal/CustomMetricKindDetails';
import { PageviewMetricDetails } from '../internal/CreateMetricModal/PageviewMetricDetails';

import type { MetricForm } from './formUtils';

type MetricKindDetailsProps = {
  context: UseFormReturn<MetricForm>;
  metricKind: Metric['kind'];
  /**
   * The measurement window and winsorization settings, rendered with the source configuration.
   * Every kind gets them: winsorization is available to LaunchDarkly-hosted sources, which is
   * what click and page view metrics always are.
   */
  winsorizationAndWindowing?: React.ReactNode;
  /** Renders the sectioned layout. Only the create modal opts in so far. */
  useSectionedLayout?: boolean;
  isEdit?: boolean;
};

export const MetricKindDetails: React.FC<MetricKindDetailsProps> = ({
  context,
  metricKind,
  winsorizationAndWindowing,
  useSectionedLayout = false,
  isEdit = false,
}) => {
  if (metricKind === 'custom' || metricKind === 'trace') {
    return (
      <CustomMetricKindDetails
        context={context}
        winsorizationAndWindowing={winsorizationAndWindowing}
        useSectionedLayout={useSectionedLayout}
        isEdit={isEdit}
      />
    );
  } else if (metricKind === 'click') {
    return (
      <ClickMetricDetails
        context={context}
        winsorizationAndWindowing={winsorizationAndWindowing}
        useSectionedLayout={useSectionedLayout}
      />
    );
  } else if (metricKind === 'pageview') {
    return (
      <PageviewMetricDetails
        context={context}
        winsorizationAndWindowing={winsorizationAndWindowing}
        useSectionedLayout={useSectionedLayout}
      />
    );
  }
  return null;
};
